export enum PriceMultiplierEnum {
    MULTIPLY = 'MULTIPLY',
    DIVIDE = 'DIVIDE',
}

export const priceMultiplier = [
    { id: PriceMultiplierEnum.MULTIPLY, value: 'Умножение' },
    { id: PriceMultiplierEnum.DIVIDE, value: 'Деление' },
];
